import * as types from '../../../../types/masters/stoneAttribute/stoneCut/stoneCutTypes';
import * as api from '../../../../../api/masters/stoneAttribute/stoneCut/stoneCutApi';

export const fetchStoneCuts = () => async (dispatch) => {
  dispatch({ type: types.FETCH_STONE_CUT_REQUEST });
  try {
    const data = await api.fetchStoneCuts();
    dispatch({ type: types.FETCH_STONE_CUT_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: types.FETCH_STONE_CUT_FAILURE, payload: error.message });
  }
};

export const addStoneCut = (stoneCut) => async (dispatch) => {
  try {
    const res = await api.addStoneCut(stoneCut);
    dispatch({ type: types.ADD_STONE_CUT_SUCCESS, payload: res });
    dispatch(fetchStoneCuts());
  } catch (error) {
    dispatch({ type: types.STONE_CUT_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const updateStoneCut = (id, stoneCut) => async (dispatch) => {
  try {
    console.log('Updating stone cut with ID:', id, 'Data:', stoneCut);
    const res = await api.updateStoneCut(id, stoneCut);
    console.log('Update response:', res);
    dispatch({ type: types.UPDATE_STONE_CUT_SUCCESS, payload: res });
    dispatch(fetchStoneCuts());
  } catch (error) {
    console.error('Update error:', error);
    dispatch({ type: types.STONE_CUT_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const deleteStoneCut = (id) => async (dispatch) => {
  try {
    await api.deleteStoneCut(id);
    dispatch({ type: types.DELETE_STONE_CUT_SUCCESS, payload: id });
    dispatch(fetchStoneCuts());
  } catch (error) {
    dispatch({ type: types.STONE_CUT_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const setStoneCutEdit = (stoneCut) => ({
  type: types.SET_STONE_CUT_EDIT,
  payload: stoneCut,
});

export const clearStoneCutEdit = () => ({
  type: types.CLEAR_STONE_CUT_EDIT,
}); 